import * as animation1 from '../assets/animations/ki_l1_v01.json'
import * as animation2 from '../assets/animations/ki_l2_v01.json'
import * as animation3 from '../assets/animations/ki_l3_v01.json'
import * as animation4 from '../assets/animations/ki_l4_v01.json'
import * as animation7 from '../assets/animations/ki_l5_v01.json'

// @ts-ignore
const ServicesCardData = [
    {
        desc: "Параллельный <br class='br'/> импорт",
        animation: animation7,
        path: '/parallelnyy-import-oborudovaniya'
    },
    {
        desc: "Второе <br class='br'/> гражданство",
        animation: animation2,
        path: '/vtoroe-grazhdanstvo'
    },
    {
        desc: "Сопровождение <br class='br'/> уголовных дел",
        animation: animation4,
        path: '/soprovozhdenie-ugolovnyh-del'
    },
    {
        desc: "Комплексная защита&nbsp;<br /> должников от кредиторов",
        animation: animation1,
        path: '/zashchita-dolzhnikov-ot-kreditorov'
    },
    {
        desc: "Сопровождение на всех стадиях банкротства в интересах должника",
        animation: animation3,
        path: '/yuridicheskoe-soprovozhdenie-bankrotstva'
    },
    {
        desc: "Защита от субсидиарной ответственности",
        animation: animation2,
        path: '/zashchita-ot-subsidiarnoy-otvetstvennosti'
    },
]

export default ServicesCardData;
